import React from "react";
import { NavLink } from "react-router-dom";
import { IMAGE_TOOLS } from "./playgroundTools";
import "./PlaygroundMenu.css";

export default function PlaygroundMenu() {
  const items = [
    { id: "home", title: "Home", icon: "⌂", path: "/" },
    { id: "playground", title: "Playground", icon: "🎮", path: "/image-generator" },
    ...IMAGE_TOOLS.filter((tool) => !tool.comingSoon).map((tool) => ({
      ...tool,
      title: tool.id === "plushie-avatar" ? "Plushie Avatar" : tool.title,
      path: tool.external ? tool.path : `/image-generator/${tool.id}`,
    })),
  ];

  return (
    <nav className="playground-menu" aria-label="Playground navigation">
      <div className="playground-menu-items">
        {items.map((item) => item.external ? (
          <a key={item.id} className="playground-menu-item" href={item.path} target="_blank" rel="noopener noreferrer">
            <span aria-hidden="true">{item.icon}</span>{item.title}
          </a>
        ) : (
          <NavLink key={item.id} to={item.path} end className={({ isActive }) => `playground-menu-item${isActive ? " is-active" : ""}`}>
            <span aria-hidden="true">{item.icon}</span>{item.title}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
